<template>
  <Teleport to="body">
    <div class="toast-container gap-8 p-fixed d-flex column items-center w-100">
      <TransitionGroup name="toast">
        <div v-for="toast in toasts" :key="toast.id" class="toast w-100 d-flex items-center justify-between bg-toast-bg color-toast-color" :class="toast.type">
          <div class="w-100 gap-8 d-flex items-center justify-between">
            <div class="d-flex items-center">
              <Icons :name="toast.type" />
            </div>
            <span class="leaning-24">{{ toast.message }}</span>
            <div class="close-icon d-flex items-center" @click="() => removeToast(toast.id)">
              <Icons name="toastClose" />
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
import Icons from '@/components/base/icon/index.vue';
import { useToast } from '@/composabels/useToast';

const { toasts, removeToast } = useToast();
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
